webpackJsonp([5],{

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryEventCreate_vue__ = __webpack_require__(1234);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6d5688c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryEventCreate_vue__ = __webpack_require__(1306);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryEventCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6d5688c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryEventCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning'
    },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: {
      type: Boolean,
      default: false
    },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dismissed: false
    };
  },
  mounted: function mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert();
  },
  watch: {
    message: function message(val) {
      this.dismissed = false;
      if (val) this.scrollToAlert();
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss: function dismiss() {
      this.dismissed = true;
      this.$emit('dismiss');
    },
    scrollToAlert: function scrollToAlert() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el) {
          _this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcd5d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FTextarea',
  components: {
    FGroup: __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__["a" /* default */]
  },
  props: {
    value: {
      default: ''
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    rows: {
      default: 3
    },
    required: Boolean,
    placeholder: String,
    tooltip: String,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("416c99d6", content, true, {});

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".form-alert[data-v-3fcd5d34]{padding:.75rem 0}.form-alert--flush[data-v-3fcd5d34]{padding:0}.form-alert__body[data-v-3fcd5d34]{cursor:pointer;white-space:pre-line;text-align:left}.fade-enter-active[data-v-3fcd5d34]{transition:opacity .3s}.fade-leave-active[data-v-3fcd5d34]{transition:opacity .15s}.fade-enter[data-v-3fcd5d34],.fade-leave-to[data-v-3fcd5d34]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormAlert.vue"],"names":[],"mappings":"AACA,6BACE,gBAAmB,CACpB,AACD,oCACE,SAAW,CACZ,AACD,mCACE,eAAgB,AAMhB,qBAAsB,AACtB,eAAiB,CANlB,AAQD,oCACE,sBAAyB,CAC1B,AACD,oCACE,uBAA0B,CAC3B,AACD,6DAEE,SAAW,CACZ","file":"FormAlert.vue","sourcesContent":["\n.form-alert[data-v-3fcd5d34] {\n  padding: 0.75rem 0;\n}\n.form-alert--flush[data-v-3fcd5d34] {\n  padding: 0;\n}\n.form-alert__body[data-v-3fcd5d34] {\n  cursor: pointer;\n}\n\n/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)\n   so they render one per line instead of a run-on sentence. */\n.form-alert__body[data-v-3fcd5d34] {\n  white-space: pre-line;\n  text-align: left;\n}\n.fade-enter-active[data-v-3fcd5d34] {\n  transition: opacity 0.3s;\n}\n.fade-leave-active[data-v-3fcd5d34] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-3fcd5d34],\n.fade-leave-to[data-v-3fcd5d34] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message && !_vm.dismissed)?_c('div',{staticClass:"form-alert",class:{ 'form-alert--flush': _vm.flush },attrs:{"role":"alert"}},[_c('div',{staticClass:"form-alert__body alert-pop",class:("alert alert-" + _vm.type + " mb-0"),attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useFormAlert() {
  var message = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var type = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('warning');
  var timer = null;

  function apply(msg, autoDismiss) {
    message.value = msg;

    if (autoDismiss) {
      timer = setTimeout(function () {
        message.value = null;
      }, 5000);
    }
  }

  function show(msg, alertType, autoDismiss) {
    clearTimeout(timer);
    type.value = alertType;

    if (message.value != null) {
      message.value = null;
      Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
        return apply(msg, autoDismiss);
      });
    } else {
      apply(msg, autoDismiss);
    }
  }

  function showError(msg) {
    show(msg, 'warning', true);
  }

  function showSuccess(msg) {
    show(msg != null ? msg : 'Success', 'success', true);
  }

  function showPersistentError(msg) {
    show(msg, 'warning', false);
  }

  function clear() {
    clearTimeout(timer);
    message.value = null;
  }

  return {
    message: message,
    type: type,
    showError: showError,
    showSuccess: showSuccess,
    showPersistentError: showPersistentError,
    clear: clear
  };
}

/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__ = __webpack_require__(1128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__ = __webpack_require__(1134);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfa61c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"id":_vm.id,"required":_vm.required,"tooltip":_vm.tooltip,"error":_vm.error}},[_c('textarea',{class:['form-control', _vm.error && 'is-invalid'],attrs:{"id":_vm.id,"rows":_vm.rows,"required":_vm.required,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppButton__ = __webpack_require__(92);
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MobileSubmitButton',
  components: {
    AppButton: __WEBPACK_IMPORTED_MODULE_0__components_AppButton__["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    noBottom: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  eventTypes: function eventTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/event-types');
  },
  create: function create(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/events"), data, {
      silent: true
    });
  },
  getEdit: function getEdit(draftId, eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/events/").concat(eventId, "/edit"));
  },
  update: function update(draftId, eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put("/v2/drafts/".concat(draftId, "/events/").concat(eventId), data, {
      silent: true
    });
  },
  // localSuccess: the caller shows the result itself (next to the event); without it the http client
  // would also push it to the page-top alert and scroll the page up.
  destroy: function destroy(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/events/".concat(id), {
      silent: true,
      localSuccess: true
    });
  },
  reorder: function reorder(draftId, ids) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/events/reorder"), {
      ids: ids
    }, {
      silent: true,
      localSuccess: true
    });
  },
  nominationsDashboard: function nominationsDashboard(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/events/nominations-dashboard"));
  },
  lock: function lock(id, isLocked) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/events/".concat(id, "/lock"), {
      is_locked: isLocked
    }, {
      silent: true,
      localSuccess: true
    });
  },
  deleteSponsorLogo: function deleteSponsorLogo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/events/".concat(id, "/sponsor-logo"), {
      silent: true
    });
  },
  split: function split(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(id, "/split"), {}, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function formatSize(bytes) {
  if (bytes >= 1048576) return "".concat((bytes / 1048576).toFixed(0), " MB");
  return "".concat((bytes / 1024).toFixed(0), " KB");
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FFile',
  components: {
    FGroup: __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__["a" /* default */]
  },
  props: {
    label: String,
    id: {
      type: String,
      required: true
    },
    accept: String,
    required: Boolean,
    displayName: String,
    isInvalid: Boolean,
    tooltip: String,
    hint: String,
    maxSize: {
      type: Number,
      default: 1048576
    }
  },
  data: function data() {
    return {
      fileName: this.displayName || '',
      validationError: null
    };
  },
  watch: {
    displayName: function displayName(val) {
      this.fileName = val || '';
    }
  },
  methods: {
    onChange: function onChange(event) {
      var file = event.target.files[0];

      if (!file) {
        this.validationError = null;
        this.fileName = '';
        return;
      }

      var sizeError = this.validateSize(file);

      if (sizeError) {
        this.validationError = sizeError;
        this.fileName = '';
        this.$refs.input.value = '';
        return;
      }

      var typeError = this.validateType(file);

      if (typeError) {
        this.validationError = typeError;
        this.fileName = '';
        this.$refs.input.value = '';
        return;
      }

      this.validationError = null;
      this.fileName = file.name;
      this.$emit('change', event);
    },
    validateSize: function validateSize(file) {
      if (file.size > this.maxSize) {
        return "File is too large. Maximum size is ".concat(formatSize(this.maxSize), ".");
      }

      return null;
    },
    validateType: function validateType(file) {
      if (!this.accept) return null;
      var tokens = this.accept.split(',').map(function (t) {
        return t.trim().toLowerCase();
      });
      var fileExt = file.name.split('.').pop().toLowerCase();
      var allowed = tokens.some(function (token) {
        var normalized = token.startsWith('.') ? token : ".".concat(token);

        if (normalized.includes('/')) {
          return token.endsWith('/*') ? file.type.startsWith(token.slice(0, -1)) : file.type === token;
        }

        return file.name.toLowerCase().endsWith(normalized) || fileExt === token.replace(/^\./, '');
      });

      if (!allowed) {
        var exts = tokens.map(function (t) {
          return t.startsWith('.') ? t.slice(1) : t;
        }).join(', ');
        return "Invalid file type. Allowed: ".concat(exts, ".");
      }

      return null;
    }
  }
});

/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FImagePreview',
  props: {
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ''
    },
    deletable: {
      type: Boolean,
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: !!this.src
    };
  },
  watch: {
    src: function src(val) {
      this.loading = !!val;
    }
  }
});

/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileSubmitButton_vue__ = __webpack_require__(1137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6370764f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileSubmitButton_vue__ = __webpack_require__(1149);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileSubmitButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6370764f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileSubmitButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['d-lg-none mt-3', _vm.noBottom ? '' : 'mb-4']},[_c('app-button',{attrs:{"type":"submit","loading":_vm.loading}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FFile__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FImagePreview__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Events_EventFieldsSection__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Events_EventFieldsNameSection__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Docs_DocModal__ = __webpack_require__(441);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var JUDGES_OPTIONS = [1, 2, 3].map(function (n) {
  return {
    id: n,
    name: String(n)
  };
});
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventForm',
  components: {
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_0__components_ConfirmModal__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_1__components_FormAlert__["a" /* default */],
    FText: __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FText__["a" /* default */],
    FFile: __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FFile__["a" /* default */],
    FImagePreview: __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FImagePreview__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FCheckbox__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FSearchSelect__["a" /* default */],
    EventFieldsSection: __WEBPACK_IMPORTED_MODULE_7__components_Events_EventFieldsSection__["a" /* default */],
    EventFieldsNameSection: __WEBPACK_IMPORTED_MODULE_8__components_Events_EventFieldsNameSection__["a" /* default */],
    DocModal: __WEBPACK_IMPORTED_MODULE_9__components_Docs_DocModal__["a" /* default */]
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    sharedForm: {
      type: Object,
      required: true
    },
    eventTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingTypes: {
      type: Boolean,
      default: false
    },
    isCombined: {
      type: Boolean,
      default: false
    },
    brotherId: {
      type: Number,
      default: null
    },
    lockToggles: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    alert: {
      type: Object,
      default: function _default() {
        return {
          message: null,
          type: 'warning'
        };
      }
    },
    sponsorLogoUrl: {
      type: String,
      default: null
    },
    deletingLogo: {
      type: Boolean,
      default: false
    },
    availableJudges: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingJudges: {
      type: Boolean,
      default: false
    },
    judgeIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      confirmPending: null,
      showGuide: false,
      checkboxKey: 0
    };
  },
  computed: {
    judgesOptions: function judgesOptions() {
      return JUDGES_OPTIONS;
    },
    selectedType0Defaults: function selectedType0Defaults() {
      var _this = this;

      var selected = this.eventTypes.find(function (t) {
        return t.id === _this.events[0].event_type_id;
      });
      return selected != null ? selected.defaults : {};
    },
    requiresHorse: function requiresHorse() {
      return this.selectedType0Defaults.requires_horse !== false;
    },
    hasJudges: function hasJudges() {
      return this.selectedType0Defaults.has_judges !== false;
    },
    hasDeclaredPrize: function hasDeclaredPrize() {
      return this.selectedType0Defaults.has_declared_prize !== false;
    },
    // Hidden is a fixed restriction: it can never be used in a combined event (backend
    // enforces this on both create and edit) — same rule as the no-horse-required types below,
    // just keyed by name instead of a capability flag since Hidden still requires a horse.
    isFirstEventHidden: function isFirstEventHidden() {
      var _this2 = this;

      var type = this.eventTypes.find(function (t) {
        var _this2$events$;

        return t.id === ((_this2$events$ = _this2.events[0]) === null || _this2$events$ === void 0 ? void 0 : _this2$events$.event_type_id);
      });
      return (type === null || type === void 0 ? void 0 : type.name) === 'Hidden';
    },
    firstEventCombinable: function firstEventCombinable() {
      return this.requiresHorse && !this.isFirstEventHidden;
    },
    combinableEventTypes: function combinableEventTypes() {
      return this.eventTypes.filter(function (t) {
        return t.defaults.requires_horse !== false && t.name !== 'Hidden';
      });
    }
  },
  methods: {
    onCombinedInput: function onCombinedInput(val) {
      if (val) {
        this.confirmPending = 'combined';
      } else {
        this.$emit('toggle-combined', false);
      }
    },
    onConjunctionInput: function onConjunctionInput(val) {
      if (val) {
        this.confirmPending = 'conjunction';
      } else {
        this.$emit('update-shared', 'is_conjunction', false);
      }
    },
    onConfirm: function onConfirm() {
      if (this.confirmPending === 'combined') {
        this.$emit('toggle-combined', true);
      } else if (this.confirmPending === 'conjunction') {
        this.$emit('update-shared', 'is_conjunction', true);
        this.$emit('update-shared', 'discount_price', null);
      }

      this.confirmPending = null;
    },
    onCancelConfirm: function onCancelConfirm() {
      this.confirmPending = null;
      this.checkboxKey += 1;
    },
    sharedError: function sharedError(field) {
      return this.errors[field] ? this.errors[field][0] : null;
    },
    judgeLabel: function judgeLabel(judge) {
      return "".concat(judge.first_name, " ").concat(judge.last_name);
    },
    onJudgesNumChange: function onJudgesNumChange(val) {
      this.$emit('update-shared', 'judges_num', val != null ? val : 1);
    },
    onLogoChange: function onLogoChange(event) {
      var file = event.target.files[0];
      this.$emit('logo-change', file != null ? file : null);
    }
  }
});

/***/ }),

/***/ 1172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FFile_vue__ = __webpack_require__(1144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a4f5fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FFile_vue__ = __webpack_require__(1173);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a4f5fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"hint":_vm.hint}},[_c('div',{staticClass:"custom-file"},[_c('input',{ref:"input",class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.isInvalid || !!_vm.validationError }],attrs:{"type":"file","id":_vm.id,"accept":_vm.accept,"required":_vm.required},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":_vm.id}},[_vm._v("\n      "+_vm._s(_vm.fileName || 'Select File')+"\n    ")]),_vm._v(" "),(_vm.validationError)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.validationError))]):(_vm.tooltip)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.tooltip))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FImagePreview_vue__ = __webpack_require__(1145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9ef1fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FImagePreview_vue__ = __webpack_require__(1177);
function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c9ef1fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FImagePreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9ef1fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FImagePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1175:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1176);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("725c5495", content, true, {});

/***/ }),

/***/ 1176:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".f-image-preview__spinner[data-v-6c9ef1fd]{display:flex;align-items:center;justify-content:center;height:80px}.f-image-preview__wrap[data-v-6c9ef1fd]{position:relative;display:inline-block;width:auto;max-width:100%}.f-image-preview__delete[data-v-6c9ef1fd]{position:absolute;top:0;right:0;width:30px;height:30px;padding:0;border:none;background-color:transparent;background-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' fill='white'/%3e%3cg clip-path='url(%23clip0)'%3e%3cpath d='M20.55 20.95C20.45 20.95 20.25 20.95 20.15 20.85L10.15 10.85C9.95 10.65 9.95 10.35 10.15 10.15C10.35 9.95 10.65 9.95 10.85 10.15L20.85 20.15C21.05 20.35 21.05 20.65 20.85 20.85C20.85 20.95 20.65 20.95 20.55 20.95Z' fill='%23A2A0A0'/%3e%3cpath d='M10.55 20.95C10.45 20.95 10.25 20.95 10.15 20.85C9.95 20.65 9.95 20.35 10.15 20.15L20.15 10.15C20.35 9.95 20.65 9.95 20.85 10.15C21.05 10.35 21.05 10.65 20.85 10.85L10.85 20.85C10.85 20.95 10.65 20.95 10.55 20.95Z' fill='%23A2A0A0'/%3e%3c/g%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' stroke='%23A2A0A0'/%3e%3cdefs%3e%3cclipPath id='clip0'%3e%3crect width='11' height='11' fill='white' transform='translate(10 10)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e\");background-size:contain;background-repeat:no-repeat;cursor:pointer}.f-image-preview__delete[data-v-6c9ef1fd]:disabled{cursor:not-allowed;opacity:.7}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormFields/FImagePreview.vue"],"names":[],"mappings":"AACA,2CACE,aAAc,AACd,mBAAoB,AACpB,uBAAwB,AACxB,WAAa,CACd,AACD,wCACE,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,cAAgB,CACjB,AACD,0CACE,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,WAAY,AACZ,YAAa,AACb,UAAW,AACX,YAAa,AACb,6BAA8B,AAC9B,69BAA89B,AAC99B,wBAAyB,AACzB,4BAA6B,AAC7B,cAAgB,CACjB,AACD,mDACE,mBAAoB,AACpB,UAAa,CACd","file":"FImagePreview.vue","sourcesContent":["\n.f-image-preview__spinner[data-v-6c9ef1fd] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 80px;\n}\n.f-image-preview__wrap[data-v-6c9ef1fd] {\n  position: relative;\n  display: inline-block;\n  width: auto;\n  max-width: 100%;\n}\n.f-image-preview__delete[data-v-6c9ef1fd] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' fill='white'/%3e%3cg clip-path='url(%23clip0)'%3e%3cpath d='M20.55 20.95C20.45 20.95 20.25 20.95 20.15 20.85L10.15 10.85C9.95 10.65 9.95 10.35 10.15 10.15C10.35 9.95 10.65 9.95 10.85 10.15L20.85 20.15C21.05 20.35 21.05 20.65 20.85 20.85C20.85 20.95 20.65 20.95 20.55 20.95Z' fill='%23A2A0A0'/%3e%3cpath d='M10.55 20.95C10.45 20.95 10.25 20.95 10.15 20.85C9.95 20.65 9.95 20.35 10.15 20.15L20.15 10.15C20.35 9.95 20.65 9.95 20.85 10.15C21.05 10.35 21.05 10.65 20.85 10.85L10.85 20.85C10.85 20.95 10.65 20.95 10.55 20.95Z' fill='%23A2A0A0'/%3e%3c/g%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' stroke='%23A2A0A0'/%3e%3cdefs%3e%3cclipPath id='clip0'%3e%3crect width='11' height='11' fill='white' transform='translate(10 10)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n.f-image-preview__delete[data-v-6c9ef1fd]:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-image-preview mb-3 pt-3"},[(_vm.loading)?_c('div',{staticClass:"f-image-preview__spinner"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-secondary"})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"f-image-preview__wrap"},[(_vm.src)?_c('img',{staticClass:"w-100",staticStyle:{"max-height":"400px","object-fit":"contain"},attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":function($event){_vm.loading = false},"error":function($event){_vm.loading = false}}}):_vm._e(),_vm._v(" "),(_vm.deletable)?_c('button',{staticClass:"f-image-preview__delete",attrs:{"type":"button","disabled":_vm.deleting},on:{"click":function($event){return _vm.$emit('delete')}}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FTextarea__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FSearchSelect__ = __webpack_require__(436);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var ROUNDS_OPTIONS = [{
  id: 1,
  name: '1'
}, {
  id: 2,
  name: '2'
}, {
  id: 3,
  name: '3'
}, {
  id: 4,
  name: '4'
}, {
  id: 5,
  name: '5'
}];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventFieldsSection',
  components: {
    FText: __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__["a" /* default */],
    FTextarea: __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FTextarea__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FCheckbox__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FSearchSelect__["a" /* default */]
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    eventTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingTypes: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    },
    isCombined: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      roundsOptions: ROUNDS_OPTIONS,
      riderSexOptions: [{
        id: 1,
        name: 'Male'
      }, {
        id: 2,
        name: 'Female'
      }, {
        id: 3,
        name: 'All'
      }]
    };
  },
  computed: {
    roundsValue: function roundsValue() {
      if (this.isCombined) return 2;
      return this.value.rounds;
    },
    isFuturity: function isFuturity() {
      var _this = this;

      if (!this.value.event_type_id) return false;
      var selected = this.eventTypes.find(function (t) {
        return t.id === _this.value.event_type_id;
      });
      return selected != null && selected.name.toLowerCase() === 'futurity';
    },
    selectedTypeDefaults: function selectedTypeDefaults() {
      var _this2 = this;

      var selected = this.eventTypes.find(function (t) {
        return t.id === _this2.value.event_type_id;
      });
      return selected != null ? selected.defaults : {};
    },
    requiresHorse: function requiresHorse() {
      return this.selectedTypeDefaults.requires_horse !== false;
    },
    hasHorseRestrictions: function hasHorseRestrictions() {
      return this.selectedTypeDefaults.has_horse_restrictions !== false;
    },
    hasRounds: function hasRounds() {
      return this.selectedTypeDefaults.has_rounds !== false;
    }
  },
  watch: {
    isFuturity: function isFuturity(val) {
      if (val) this.$emit('input', _objectSpread({}, this.value, {
        horses_max_age: 5
      }));
    }
  },
  methods: {
    e: function e(field) {
      var key = "events.".concat(this.index, ".").concat(field);
      return this.errors[key] ? this.errors[key][0] : null;
    },
    update: function update(field, val) {
      if (field === 'ashs' && val) {
        this.$emit('input', _objectSpread({}, this.value, {
          ashs: true,
          aqha: false
        }));
      } else if (field === 'aqha' && val) {
        this.$emit('input', _objectSpread({}, this.value, {
          ashs: false,
          aqha: true
        }));
      } else {
        this.$emit('input', _objectSpread({}, this.value, _defineProperty({}, field, val)));
      }
    }
  }
});

/***/ }),

/***/ 1179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FTextarea__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FSearchSelect__ = __webpack_require__(436);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventFieldsSection',
  components: {
    FText: __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FText__["a" /* default */],
    FTextarea: __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FTextarea__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FCheckbox__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FSearchSelect__["a" /* default */]
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    eventTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingTypes: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    e: function e(field) {
      var key = "events.".concat(this.index, ".").concat(field);
      return this.errors[key] ? this.errors[key][0] : null;
    },
    update: function update(field, val) {
      this.$emit('input', _objectSpread({}, this.value, _defineProperty({}, field, val)));
    }
  }
});

/***/ }),

/***/ 1208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventForm_vue__ = __webpack_require__(1171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430b6d6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventForm_vue__ = __webpack_require__(1213);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430b6d6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventFieldsSection_vue__ = __webpack_require__(1178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d294420_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventFieldsSection_vue__ = __webpack_require__(1210);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventFieldsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d294420_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventFieldsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__pair"},[_c('f-search-select',{attrs:{"id":("event_rounds_" + _vm.index),"label":"Rounds","value":_vm.roundsValue,"options":_vm.roundsOptions,"searchable":false,"disabled":_vm.isCombined || !_vm.hasRounds,"required":"","error":_vm.e('rounds'),"hint":"Rounds including final"},on:{"input":function($event){return _vm.update('rounds', $event)}}}),_vm._v(" "),_c('f-text',{attrs:{"id":("event_max_submissions_" + _vm.index),"label":"Maximum Submissions Per Person","type":"number","min":"0","disabled":_vm.requiresHorse,"hint":"Leave blank or 0 if unlimited","value":_vm.value.max_submissions,"error":_vm.e('max_submissions')},on:{"input":function($event){return _vm.update('max_submissions', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-text',{attrs:{"id":("event_final_noms_" + _vm.index),"label":"Final Noms","type":"number","value":_vm.value.final_noms,"error":_vm.e('final_noms')},on:{"input":function($event){return _vm.update('final_noms', $event)}}}),_vm._v(" "),_c('f-text',{attrs:{"id":("event_max_horses_" + _vm.index),"label":"Max Horses","type":"number","hint":"Leave blank or 0 if unlimited","disabled":!_vm.requiresHorse,"value":_vm.value.max_horses,"error":_vm.e('max_horses')},on:{"input":function($event){return _vm.update('max_horses', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair f-form__pair--3-1"},[_c('f-search-select',{attrs:{"id":("event_type_" + _vm.index),"label":"Type","value":_vm.value.event_type_id,"options":_vm.eventTypes,"track-by":"id","option-label":"name","placeholder":"Select type...","loading":_vm.loadingTypes,"required":"","error":_vm.e('event_type_id')},on:{"input":function($event){return _vm.update('event_type_id', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-text',{attrs:{"id":("riders_min_age_" + _vm.index),"label":"Riders Min Age","type":"number","value":_vm.value.riders_min_age,"error":_vm.e('riders_min_age')},on:{"input":function($event){return _vm.update('riders_min_age', $event)}}}),_vm._v(" "),_c('f-text',{attrs:{"id":("riders_max_age_" + _vm.index),"label":"Riders Max Age","type":"number","value":_vm.value.riders_max_age,"hint":"Leave blank or 0 if unlimited","error":_vm.e('riders_max_age')},on:{"input":function($event){return _vm.update('riders_max_age', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-search-select',{attrs:{"id":("riders_sex_" + _vm.index),"label":"Rider Sex","value":_vm.value.riders_sex,"options":_vm.riderSexOptions,"searchable":false,"error":_vm.e('riders_sex')},on:{"input":function($event){return _vm.update('riders_sex', $event)}}}),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center h-100 pt-3"},[_c('f-checkbox',{attrs:{"fontNormal":true,"labelBold":false,"id":("riders_maiden_" + _vm.index),"label":"Maiden rider","value":_vm.value.riders_maiden},on:{"input":function($event){return _vm.update('riders_maiden', $event)}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-text',{attrs:{"id":("back_amount_" + _vm.index),"label":"Added Entry/Add Back","type":"number","value":_vm.value.back_amount,"error":_vm.e('back_amount')},on:{"input":function($event){return _vm.update('back_amount', $event)}}}),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center h-100 pt-3"},[_c('f-checkbox',{attrs:{"fontNormal":true,"labelBold":false,"id":("is_affiliated_" + _vm.index),"label":"Yes, it is an affiliated event","value":_vm.value.is_affiliated},on:{"input":function($event){return _vm.update('is_affiliated', $event)}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-textarea',{attrs:{"id":("notes_" + _vm.index),"label":"Notes","rows":6,"value":_vm.value.notes,"error":_vm.e('notes')},on:{"input":function($event){return _vm.update('notes', $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-text',{attrs:{"id":("horses_min_age_" + _vm.index),"label":"Horse Min Age","type":"number","hint":"Leave blank or 0 if unlimited","value":_vm.value.horses_min_age,"disabled":!_vm.hasHorseRestrictions,"error":_vm.e('horses_min_age')},on:{"input":function($event){return _vm.update('horses_min_age', $event)}}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column",staticStyle:{"gap":"1rem"}},[_c('f-text',{attrs:{"id":("horses_max_age_" + _vm.index),"label":"Horse Max Age","type":"number","hint":"Leave blank or 0 if unlimited","value":_vm.value.horses_max_age,"disabled":_vm.isFuturity || !_vm.hasHorseRestrictions,"error":_vm.e('horses_max_age')},on:{"input":function($event){return _vm.update('horses_max_age', $event)}}}),_vm._v(" "),_c('f-checkbox',{attrs:{"fontNormal":true,"disabled":!_vm.hasHorseRestrictions,"id":("hc1_" + _vm.index),"label":"Futurity","value":_vm.value.horses_class_1},on:{"input":function($event){return _vm.update('horses_class_1', $event)}}}),_vm._v(" "),_c('f-checkbox',{attrs:{"fontNormal":true,"disabled":!_vm.hasHorseRestrictions,"id":("hc2_" + _vm.index),"label":"Maiden","value":_vm.value.horses_class_2},on:{"input":function($event){return _vm.update('horses_class_2', $event)}}}),_vm._v(" "),_c('f-checkbox',{attrs:{"fontNormal":true,"disabled":!_vm.hasHorseRestrictions,"id":("hc3_" + _vm.index),"label":"Novice","value":_vm.value.horses_class_3},on:{"input":function($event){return _vm.update('horses_class_3', $event)}}}),_vm._v(" "),_c('f-checkbox',{attrs:{"fontNormal":true,"disabled":!_vm.hasHorseRestrictions,"id":("hc4_" + _vm.index),"label":"Open","value":_vm.value.horses_class_4},on:{"input":function($event){return _vm.update('horses_class_4', $event)}}}),_vm._v(" "),_c('f-checkbox',{attrs:{"fontNormal":true,"disabled":!_vm.hasHorseRestrictions,"id":("hc5_" + _vm.index),"label":"Any","value":_vm.value.horses_class_5},on:{"input":function($event){return _vm.update('horses_class_5', $event)}}}),_vm._v(" "),_c('f-checkbox',{attrs:{"fontNormal":true,"disabled":!_vm.hasHorseRestrictions,"id":("ashs_" + _vm.index),"label":"ASHS","value":_vm.value.ashs},on:{"input":function($event){return _vm.update('ashs', $event)}}}),_vm._v(" "),_c('div',[_c('f-checkbox',{attrs:{"fontNormal":true,"disabled":!_vm.hasHorseRestrictions,"id":("aqha_" + _vm.index),"label":"AQHA","value":_vm.value.aqha},on:{"input":function($event){return _vm.update('aqha', $event)}}}),_vm._v(" "),(_vm.e('aqha'))?_c('small',{staticClass:"text-danger d-block"},[_vm._v(_vm._s(_vm.e('aqha')))]):_vm._e()],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventFieldsNameSection_vue__ = __webpack_require__(1179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92696046_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventFieldsNameSection_vue__ = __webpack_require__(1212);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventFieldsNameSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92696046_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventFieldsNameSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-form__pair f-form__pair--3-1"},[_c('f-text',{attrs:{"id":("event_name_" + _vm.index),"label":"Event Name","value":_vm.value.name,"required":"","error":_vm.e('name')},on:{"input":function($event){return _vm.update('name', $event)}}}),_vm._v(" "),_c('f-text',{attrs:{"id":("event_cost_" + _vm.index),"label":"Cost","type":"number","min":"0","value":_vm.value.cost,"required":"","error":_vm.e('cost')},on:{"input":function($event){return _vm.update('cost', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-alert',{attrs:{"message":_vm.alert.message,"type":_vm.alert.type}}),_vm._v(" "),(_vm.loadingTypes)?_c('div',{staticClass:"text-center py-5"},[_vm._m(0)]):[_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__full"},[_c('div',{staticClass:"alert alert-info alert-simple mb-3"},[_vm._v("\n          For an overview of how events work and what each setting is responsible for, see the\n          "),_c('button',{staticClass:"btn btn-link p-0 align-baseline",attrs:{"type":"button"},on:{"click":function($event){_vm.showGuide = true}}},[_vm._v("event guide")]),_vm._v(".\n        ")]),_vm._v(" "),(_vm.brotherId == null && _vm.isCombined && !_vm.sharedForm.is_conjunction)?_c('div',{staticClass:"alert alert-info alert-simple mb-3"},[_vm._v("\n          This is a combined event. When nominating, competitors will have three options to select from: Event 1, Event 2, or Event 1 & 2.\n        ")]):_vm._e(),_vm._v(" "),(_vm.brotherId == null && _vm.sharedForm.is_conjunction)?_c('div',{staticClass:"alert alert-info alert-simple mb-3"},[_vm._v("\n          This is a conjunction event. When nominating, competitors will have two options to select from:\n          Event 1 or Event 1 & 2.\n        ")]):_vm._e(),_vm._v(" "),(_vm.brotherId != null && _vm.sharedForm.is_conjunction)?_c('div',{staticClass:"alert alert-info alert-simple mb-3"},[_vm._v("\n          The original conjunction event has been split into 2 identical combined events, A and B,\n          plus an initially empty Event 2 Final. This action cannot be undone.\n          Nominations from the original conjunction event have been divided equally between the new A\n          and B events. Individual nominations can be moved from A to B and vice versa in the Accepted\n          Nominations area.\n          A and B have their own separate First Round and final. The Event 2 Final will be populated\n          based on the minimum score set on the Draws page for events A and B.\n        ")]):(_vm.brotherId != null && _vm.isCombined)?_c('div',{staticClass:"alert alert-info alert-simple mb-3"},[_vm._v("\n          The original combined event has been split into 2 identical combined events, A and B. This\n          action cannot be undone. Nominations from the original event have been divided equally between\n          the new A and B events. Individual nominations can be moved from A to B and vice versa in the\n          Accepted Nominations area. Each combined event has a joint First Round and a separate final,\n          resulting in four separate finals in total.\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('f-checkbox',{key:("combined_" + _vm.checkboxKey),attrs:{"id":"is_combined","label":"Combined events","value":_vm.isCombined,"lock-if-true":_vm.lockToggles,"disabled":_vm.brotherId != null || !_vm.firstEventCombinable,"font-normal":true},on:{"input":_vm.onCombinedInput}}),_vm._v(" "),(_vm.isCombined)?_c('f-checkbox',{key:("conjunction_" + _vm.checkboxKey),staticClass:"ml-4",attrs:{"id":"is_conjunction","label":"Conjunction events","value":_vm.sharedForm.is_conjunction,"lock-if-true":_vm.lockToggles,"disabled":_vm.brotherId != null && !_vm.sharedForm.is_conjunction,"font-normal":true},on:{"input":_vm.onConjunctionInput}}):_vm._e()],1)]),_vm._v(" "),(_vm.showGuide)?_c('doc-modal',{attrs:{"doc":"events.guide","context":{ eventTypes: _vm.eventTypes }},on:{"close":function($event){_vm.showGuide = false}}}):_vm._e(),_vm._v(" "),(_vm.confirmPending)?_c('confirm-modal',{attrs:{"message":_vm.confirmPending === 'combined'
            ? 'Enabling Combined events will add a second event to this group and this action cannot be undone. Are you sure?'
            : 'Enabling Conjunction event will set Cost with a discount to the sum of event costs and this action cannot be undone. Are you sure?'},on:{"confirm":_vm.onConfirm,"cancel":_vm.onCancelConfirm}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('event-fields-name-section',{attrs:{"value":_vm.events[0],"errors":_vm.errors,"index":0},on:{"input":function($event){return _vm.$emit('update-event', 0, $event)}}}),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-text',{attrs:{"id":"declared_prize","label":"Declared Prize Money","type":"number","disabled":!_vm.hasDeclaredPrize,"value":_vm.sharedForm.declared_prize,"error":_vm.sharedError('declared_prize')},on:{"input":function($event){return _vm.$emit('update-shared', 'declared_prize', $event)}}})],1),_vm._v(" "),(_vm.isCombined)?_c('event-fields-name-section',{attrs:{"value":_vm.events[1],"errors":_vm.errors,"index":1},on:{"input":function($event){return _vm.$emit('update-event', 1, $event)}}}):_vm._e(),_vm._v(" "),(_vm.isCombined && !_vm.sharedForm.is_conjunction)?_c('div',{staticClass:"f-form__half f-form__half--solo"},[_c('f-text',{attrs:{"id":"discount_price","label":"Cost with a discount","type":"number","min":"0","hint":"Applied if participating in both events","value":_vm.sharedForm.discount_price,"error":_vm.sharedError('discount_price')},on:{"input":function($event){return _vm.$emit('update-shared', 'discount_price', $event)}}})],1):_vm._e()],1),_vm._v(" "),(_vm.isCombined)?_c('h3',{staticClass:"h3 mb-3"},[_vm._v("Event 1 restrictions")]):_vm._e(),_vm._v(" "),_c('event-fields-section',{attrs:{"value":_vm.events[0],"event-types":_vm.isCombined ? _vm.combinableEventTypes : _vm.eventTypes,"loading-types":false,"is-combined":_vm.isCombined,"errors":_vm.errors,"index":0},on:{"input":function($event){return _vm.$emit('update-event', 0, $event)}}}),_vm._v(" "),(_vm.isCombined)?[_c('h3',{staticClass:"h3 mb-3 mt-3"},[_vm._v("Event 2 restrictions")]),_vm._v(" "),_c('event-fields-section',{attrs:{"value":_vm.events[1],"event-types":_vm.combinableEventTypes,"loading-types":false,"is-combined":_vm.isCombined,"errors":_vm.errors,"index":1},on:{"input":function($event){return _vm.$emit('update-event', 1, $event)}}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"f-form mt-3"},[_c('div',{staticClass:"f-form__pair"},[_c('f-search-select',{attrs:{"id":"judges_num","label":"Number of Judges","value":_vm.sharedForm.judges_num,"options":_vm.judgesOptions,"searchable":false,"disabled":!_vm.hasJudges,"track-by":"id","option-label":"name","error":_vm.sharedError('judges_num')},on:{"input":_vm.onJudgesNumChange}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('f-file',{attrs:{"id":"sponsor_logo","label":"Sponsor Logo","accept":".jpg,.jpeg,.png,.webp","hint":"jpg, jpeg, png, webp — max 2 MB","max-size":2097152},on:{"change":_vm.onLogoChange}}),_vm._v(" "),(_vm.sponsorLogoUrl)?_c('f-image-preview',{attrs:{"src":_vm.sponsorLogoUrl,"deletable":true,"deleting":_vm.deletingLogo},on:{"delete":function($event){return _vm.$emit('remove-logo')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"f-form__half f-form__half--3-1"},[_c('f-search-select',{attrs:{"id":"judge_ids","label":"Judges","value":_vm.judgeIds,"options":_vm.availableJudges,"multiple":true,"disabled":!_vm.hasJudges,"track-by":"id","custom-label":_vm.judgeLabel,"placeholder":"Select judge","loading":_vm.loadingJudges,"error":_vm.sharedError('judge_ids')},on:{"input":function($event){return _vm.$emit('update-judge-ids', $event)},"search-change":function($event){return _vm.$emit('search-judges', $event)}}})],1)])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = useEventCreate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_events__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_judges__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__composables_useFormAlert__ = __webpack_require__(1132);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }





function defaultEvent() {
  return {
    name: '',
    event_type_id: null,
    cost: '',
    rounds: 1,
    max_horses: 0,
    max_submissions: null,
    notes: '',
    ashs: false,
    aqha: false,
    back_amount: null,
    is_affiliated: false,
    riders_min_age: 0,
    riders_max_age: 0,
    riders_sex: 3,
    riders_maiden: false,
    horses_min_age: 0,
    horses_max_age: 0,
    horses_class_1: false,
    horses_class_2: false,
    horses_class_3: false,
    horses_class_4: false,
    horses_class_5: false
  };
}
function useEventCreate(draftId) {
  var eventTypes = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loadingTypes = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var isCombined = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var events = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])([defaultEvent(), defaultEvent()]);
  var sharedForm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    declared_prize: '',
    judges_num: 1,
    is_conjunction: false,
    discount_price: '',
    sponsor_logo: null
  });
  var selectedJudges = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var searchResults = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loadingJudges = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var availableJudges = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    var selectedIds = selectedJudges.value.map(function (j) {
      return j.id;
    });
    var extra = searchResults.value.filter(function (j) {
      return !selectedIds.includes(j.id);
    });
    return [].concat(_toConsumableArray(selectedJudges.value), _toConsumableArray(extra));
  });
  var judgeIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return selectedJudges.value.map(function (j) {
      return j.id;
    });
  });
  var errors = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
  var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var alert = Object(__WEBPACK_IMPORTED_MODULE_3__composables_useFormAlert__["a" /* default */])();

  function searchJudges(_x) {
    return _searchJudges.apply(this, arguments);
  }

  function _searchJudges() {
    _searchJudges = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(term) {
      var params, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loadingJudges.value = true;
              _context.prev = 1;
              params = term != null && term !== '' ? {
                search: term
              } : {};
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_judges__["a" /* default */].availableForEvent(params);

            case 5:
              res = _context.sent;
              searchResults.value = res.data.data;
              _context.next = 11;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);

            case 11:
              _context.prev = 11;
              loadingJudges.value = false;
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9, 11, 14]]);
    }));
    return _searchJudges.apply(this, arguments);
  }

  function updateJudgeSelection(ids) {
    selectedJudges.value = availableJudges.value.filter(function (j) {
      return ids.includes(j.id);
    });
  }

  function loadEventTypes() {
    return _loadEventTypes.apply(this, arguments);
  }

  function _loadEventTypes() {
    _loadEventTypes = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              loadingTypes.value = true;
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_events__["a" /* default */].eventTypes();

            case 4:
              res = _context2.sent;
              eventTypes.value = res.data.data;
              _context2.next = 10;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);

            case 10:
              _context2.prev = 10;
              loadingTypes.value = false;
              return _context2.finish(10);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8, 10, 13]]);
    }));
    return _loadEventTypes.apply(this, arguments);
  }

  function applyTypeDefaults(index, typeId) {
    var found = eventTypes.value.find(function (t) {
      return t.id === typeId;
    });
    if (!found) return;
    var d = found.defaults;
    Object.assign(events[index], _objectSpread({
      riders_min_age: d.riders_min_age,
      riders_max_age: d.riders_max_age,
      riders_sex: d.riders_sex,
      riders_maiden: d.riders_maiden
    }, d.has_rounds !== false && d.rounds !== 0 && {
      rounds: d.rounds
    }, {}, d.has_horse_restrictions !== false && {
      horses_min_age: d.horses_min_age,
      horses_max_age: d.horses_max_age,
      horses_class_1: d.horse_classes.includes(1),
      horses_class_2: d.horse_classes.includes(2),
      horses_class_3: d.horse_classes.includes(3),
      horses_class_4: d.horse_classes.includes(4),
      horses_class_5: d.horse_classes.includes(5)
    }));
  }

  function updateEvent(index, updated) {
    var oldTypeId = events[index].event_type_id;
    Object.assign(events[index], updated);

    if (updated.event_type_id != null && updated.event_type_id !== oldTypeId) {
      applyTypeDefaults(index, updated.event_type_id);
    }
  }

  function updateShared(updated) {
    Object.assign(sharedForm, updated);
  }

  function submit() {
    return _submit.apply(this, arguments);
  }

  function _submit() {
    _submit = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var eventsPayload, payload, res, data, msg;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              submitting.value = true;
              errors.value = {};
              alert.clear();
              _context3.prev = 3;
              eventsPayload = isCombined.value ? [events[0], events[1]] : [events[0]];

              if (sharedForm.sponsor_logo) {
                payload = new FormData();
                payload.append('declared_prize', sharedForm.declared_prize != null ? sharedForm.declared_prize : '');
                payload.append('judges_num', sharedForm.judges_num);
                payload.append('judge_ids', JSON.stringify(judgeIds.value));
                payload.append('is_conjunction', sharedForm.is_conjunction ? '1' : '0');
                if (sharedForm.discount_price) payload.append('discount_price', sharedForm.discount_price);
                payload.append('sponsor_logo', sharedForm.sponsor_logo);
                eventsPayload.forEach(function (e, i) {
                  Object.entries(e).forEach(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        k = _ref2[0],
                        v = _ref2[1];

                    var val = v;
                    if (v === true) val = '1';else if (v === false) val = '0';else if (v == null) val = '';
                    payload.append("events[".concat(i, "][").concat(k, "]"), val);
                  });
                });
              } else {
                payload = {
                  events: eventsPayload.map(function (e) {
                    return _objectSpread({}, e);
                  }),
                  declared_prize: sharedForm.declared_prize !== '' ? sharedForm.declared_prize : null,
                  judges_num: sharedForm.judges_num,
                  judge_ids: judgeIds.value,
                  is_conjunction: sharedForm.is_conjunction,
                  discount_price: sharedForm.discount_price !== '' ? sharedForm.discount_price : null
                };
              }

              _context3.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_events__["a" /* default */].create(draftId, payload);

            case 8:
              res = _context3.sent;
              return _context3.abrupt("return", res.data.message != null ? res.data.message : true);

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);
              data = _context3.t0.response != null ? _context3.t0.response.data : null;

              if (data != null && data.errors != null) {
                errors.value = data.errors;
                msg = data.message != null ? data.message : 'Please fix the errors below.';
                alert.showError(msg);
              } else if (data != null && data.message != null) {
                alert.showError(data.message);
              }

              return _context3.abrupt("return", false);

            case 17:
              _context3.prev = 17;
              submitting.value = false;
              return _context3.finish(17);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12, 17, 20]]);
    }));
    return _submit.apply(this, arguments);
  }

  return {
    eventTypes: eventTypes,
    loadingTypes: loadingTypes,
    isCombined: isCombined,
    events: events,
    sharedForm: sharedForm,
    errors: errors,
    submitting: submitting,
    alert: alert,
    availableJudges: availableJudges,
    loadingJudges: loadingJudges,
    judgeIds: judgeIds,
    loadEventTypes: loadEventTypes,
    searchJudges: searchJudges,
    updateEvent: updateEvent,
    updateJudgeSelection: updateJudgeSelection,
    updateShared: updateShared,
    submit: submit
  };
}

/***/ }),

/***/ 1234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Events_EventForm__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MobileSubmitButton__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_events_useEventCreate__ = __webpack_require__(1214);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'SecretaryEventCreate',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    EventForm: __WEBPACK_IMPORTED_MODULE_4__components_Events_EventForm__["a" /* default */],
    MobileSubmitButton: __WEBPACK_IMPORTED_MODULE_5__components_MobileSubmitButton__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_6__components_AppButton__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_7__components_DesktopActionBar__["a" /* default */]
  },
  props: {
    draftId: {
      type: [String, Number],
      required: true
    }
  },
  setup: function setup(props) {
    var vm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])();
    var proxy = vm.proxy;

    var _useEventCreate = Object(__WEBPACK_IMPORTED_MODULE_8__composables_events_useEventCreate__["a" /* default */])(props.draftId),
        eventTypes = _useEventCreate.eventTypes,
        loadingTypes = _useEventCreate.loadingTypes,
        isCombined = _useEventCreate.isCombined,
        events = _useEventCreate.events,
        sharedForm = _useEventCreate.sharedForm,
        errors = _useEventCreate.errors,
        submitting = _useEventCreate.submitting,
        alert = _useEventCreate.alert,
        availableJudges = _useEventCreate.availableJudges,
        loadingJudges = _useEventCreate.loadingJudges,
        judgeIds = _useEventCreate.judgeIds,
        loadEventTypes = _useEventCreate.loadEventTypes,
        searchJudges = _useEventCreate.searchJudges,
        updateEvent = _useEventCreate.updateEvent,
        updateJudgeSelection = _useEventCreate.updateJudgeSelection,
        updateShared = _useEventCreate.updateShared,
        submit = _useEventCreate.submit;

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      loadEventTypes();
      searchJudges('');
      proxy.$nextTick(function () {
        proxy.$root.$emit('update-breadcrumb', {
          name: 'View Draft',
          link: "drafts/view/".concat(props.draftId)
        });
      });
    });

    function onCombinedToggle(val) {
      isCombined.value = val;

      if (!val) {
        updateShared({
          is_conjunction: false,
          discount_price: ''
        });
      }
    }

    function onUpdateShared(field, val) {
      updateShared(_defineProperty({}, field, val));
    }

    function onLogoChange(file) {
      sharedForm.sponsor_logo = file;
    }

    function handleSubmit() {
      return _handleSubmit.apply(this, arguments);
    }

    function _handleSubmit() {
      _handleSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return submit();

              case 2:
                message = _context.sent;

                if (message) {
                  proxy.$router.push({
                    name: 'Draft View',
                    params: {
                      id: props.draftId
                    }
                  }, function () {
                    proxy.$nextTick(function () {
                      __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('show-success', typeof message === 'string' ? message : 'The event has been saved.');
                    });
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _handleSubmit.apply(this, arguments);
    }

    return {
      eventTypes: eventTypes,
      loadingTypes: loadingTypes,
      isCombined: isCombined,
      events: events,
      sharedForm: sharedForm,
      errors: errors,
      submitting: submitting,
      alert: alert,
      availableJudges: availableJudges,
      loadingJudges: loadingJudges,
      judgeIds: judgeIds,
      searchJudges: searchJudges,
      updateJudgeSelection: updateJudgeSelection,
      updateEvent: updateEvent,
      onCombinedToggle: onCombinedToggle,
      onUpdateShared: onUpdateShared,
      onLogoChange: onLogoChange,
      handleSubmit: handleSubmit
    };
  }
}));

/***/ }),

/***/ 1306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('form',{staticClass:"row mx-0",attrs:{"slot":"tabContent","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}},slot:"tabContent"},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3"},[_c('page-heading',[_vm._v("Create Event")]),_vm._v(" "),_c('event-form',{attrs:{"events":_vm.events,"shared-form":_vm.sharedForm,"event-types":_vm.eventTypes,"loading-types":_vm.loadingTypes,"is-combined":_vm.isCombined,"errors":_vm.errors,"alert":{ message: _vm.alert.message.value, type: _vm.alert.type.value },"available-judges":_vm.availableJudges,"loading-judges":_vm.loadingJudges,"judge-ids":_vm.judgeIds},on:{"toggle-combined":_vm.onCombinedToggle,"update-shared":_vm.onUpdateShared,"update-event":_vm.updateEvent,"logo-change":_vm.onLogoChange,"remove-logo":function($event){_vm.sharedForm.sponsor_logo = null},"update-judge-ids":_vm.updateJudgeSelection,"search-judges":_vm.searchJudges}}),_vm._v(" "),_c('mobile-submit-button',{attrs:{"loading":_vm.submitting}},[_vm._v("\n          Create\n        ")])],1)]),_vm._v(" "),_c('desktop-action-bar',[_c('app-button',{staticClass:"px-md-5",attrs:{"type":"submit","loading":_vm.submitting}},[_vm._v("\n        Create\n      ")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.c2c6323884236c201e3e.js